export default "__VITE_ASSET__UuhrwDxQ__"